import { Activity } from "./activity";

export interface ExploreActivity extends Activity {}
